import * as React from "react"

function PointSvg(props) {
    return (
        <svg
            id="prefix__Location"
            x={0}
            y={0}
            viewBox="0 0 283.5 283.5"
            xmlSpace="preserve"
            {...props}
        >
            <style>{".PointSvg-1{fill:#003287}"}</style>
            <path fill="none" d="M0 0h283.5v283.5H0z" />
            <path
                className="PointSvg-1"
                d="M141.7 136.1c-21.9 0-39.7-17.8-39.7-39.7s17.8-39.7 39.7-39.7c21.9 0 39.7 17.8 39.7 39.7s-17.8 39.7-39.7 39.7zm0-56.7c-9.4 0-17 7.6-17 17s7.6 17 17 17 17-7.6 17-17-7.6-17-17-17z"
            />
            <path
                className="PointSvg-1"
                d="M141.7 272.1c-3.9 0-7.5-2-9.6-5.3-2.3-3.8-57.6-92.6-69.2-127.1-6.3-18.8-6.3-30.1-6.3-43.3 0-46.9 38.1-85 85-85s85 38.1 85 85c0 13.2 0 24.5-6.3 43.3-11.3 34.5-66.6 123.3-68.9 127.1-2.1 3.3-5.8 5.3-9.7 5.3zm0-238.1c-34.4 0-62.4 28-62.4 62.4 0 12.5 0 20.8 5.1 36.1 7.9 23.8 40.7 79.3 57.3 106.6 16.5-27.3 49.3-82.8 57.3-106.6 5.1-15.3 5.1-23.5 5.1-36.1 0-34.4-28-62.4-62.4-62.4z"
            />
        </svg>
    )
}

export default PointSvg
